module.exports = __webpack_public_path__ + "assets/approved-yellow.c46fd003.svg";